import ForgetPassword from 'components/ForgetPassword';
import React from 'react';

const ForgetPassswordPage = () => {
  return <ForgetPassword />;
};

export default ForgetPassswordPage;
